import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import update from 'immutability-helper';

import { Link, Redirect } from 'react-router-dom';

import Floorplan from '../../components/Floorplan/Floorplan';

import 'font-awesome/css/font-awesome.min.css';

import './Floorplans.css';

import Avatar from '@atlaskit/avatar';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css';

import {
  setTranslateX,
  setTranslateY,
  setZoom,
  loadFloorplans,
  setActiveFloorplan,
  showHidePathPopover,
  setPathPopoverX,
  setPathPopoverY,
  showHidePointPopover,
  removeFloorplan,
  toggleGridLines,
  setRotation,
  setActiveAmenity,
  setActiveKiosk,
  togglePoints,
  toggleAmenities,
  toggleKiosks,
  togglePathIDs,
  setActiveAmenityAssignment,
  showHideAmenityAssignmentPopover,
  setAmenityAssignmentPopoverX,
  setAmenityAssignmentPopoverY,
  setActiveKioskAssignment,
  showHideKioskAssignmentPopover,
  setKioskAssignmentPopoverX,
  setKioskAssignmentPopoverY,
  setActivePoint,
  setKioskAssignmentRotation,
} from '../../reducers/floorplans';

import {
  loadCheckpoints,
  loadCheckpointLinks,
  removeCheckpoint,
  loadCheckpointItems,
  addCheckpointLink,
  removeCheckpointLink,
  addCheckpointAmenity,
  removeCheckpointAmenity,
  addCheckpointKiosk,
  removeCheckpointKiosk,
  addCheckpointStoreAssignment,
  removeCheckpointStoreAssignment,
  editCheckpoint,
  editCheckpointLink
} from '../../reducers/checkpoints';

import {
  loadStoreAssignments,
  addStoreAssignment,
  removeStoreAssignment,
} from '../../reducers/stores';

import {
  loadAmenitiesAssignments,
  removeAmenityAssignment,
} from '../../reducers/amenities';

import {
  loadKiosksAssignments,
  editKiosksAssignments,
  removeKioskAssignment,
} from '../../reducers/kiosks';

import { RightSidePanel } from '@atlaskit/right-side-panel';

class Floorplans extends Component {

  state = {
    toolbar: 'select',
    redirect: false,
    floorplanPoints: [],
    activePointLinks: [],
    checkpointLinksValue: [],
    checkpointsFiltered: [],
    activePathAssignments: [],
    storesFiltered: [],
    amenitiesFiltered: [],
    activePointAmenities: [],
    kiosksFiltered: [],
    activePointKiosks: [],
    editCheckpointName: false,
    editCheckpointNameTemp: '',
    storeAssignmentsFiltered: [],
    activePointStoreAssignments: [],
    pathInfoPanel: {
      checkPointLink: null,
      show: false,
      categories: [],
      categoriesSuggestions: [],
      path_description: '',
      saving: false
    }
  }

  componentDidMount = () => { 
    this.props.loadFloorplans();   
    this.props.loadCheckpoints(() => {
      this.props.loadCheckpointLinks();
      this.props.loadCheckpointItems();
      this.props.loadStoreAssignments();
      this.props.loadAmenitiesAssignments();
      this.props.loadKiosksAssignments();
    });

    this.setInitialActiveAmenity();
    this.setInitialActiveKiosk();

    this.mapCategoriesSuggestions();
  }

  setToolbar = (toolbar) => {
    this.setState({toolbar});
  }

  setPathPopover = (popOverInfo) => {
    this.setState({popover: {show: popOverInfo.show, x: popOverInfo.x, y: popOverInfo.y}});
  }

  setInitialActiveAmenity = () => {
    if(this.props.amenities.length) {
      this.props.setActiveAmenity(this.props.amenities[0].amenity_id);
    }
  }

  setInitialActiveKiosk = () => {
    if(this.props.kiosks.length) {
      this.props.setActiveKiosk(this.props.kiosks[0].kiosk_id);
    }
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.activePath !== this.props.activePath) {
      this.loadPathTenants();
    }

    if(!this.props.isLoadingAmenities && prevProps.isLoadingAmenities !== this.props.isLoadingAmenities) {
      if(this.props.amenities.length) {
        this.setInitialActiveAmenity();
      }
    }

    if(!this.props.isLoadingKiosks && prevProps.isLoadingKiosks !== this.props.isLoadingKiosks) {
      if(this.props.kiosks.length) {
        this.setInitialActiveKiosk();
      }
    }

    if(prevProps.activePoint !== this.props.activePoint) {
      this.setState({checkpointsFiltered: [], editCheckpointNameTemp: this.props.activePoint.checkpoint_name});
      this.loadActivePointLinks();
      this.loadActivePointAmenities();
      this.loadActivePointKiosks();
      this.loadActivePointStoreAssignments();
    }

    if(!this.props.isLoadingCategories && prevProps.isLoadingCategories !== this.props.isLoadingCategories) {
      this.mapCategoriesSuggestions();
    }

    if(this.props.checkpointItems != prevProps.checkpointItems) {
      console.log('this.props.checkpointItems')
      this.props.checkpointItems.filter( (data) => {
        if(data.checkpoint.floor_plan_id == 155) {
          console.log(data.checkpoint)
        }
      })
    }

    if(this.props.storeassignments != prevProps.storeassignments) {
      console.log('this.props.storeassignments')
      // console.log(this.props.storeassignments)

      this.props.storeassignments.filter( (data) => {
        if(data.floor_plan_id == 155) {
          console.log(data)
        }
      })
    }
  }

  loadPathTenants = () => {
    const activePathAssignments = [];
    this.props.storeassignments.forEach((storeassignment) => {
      if(storeassignment.room_name === this.props.activePath) {
        activePathAssignments.push(storeassignment);
      }
    });
    this.setState({activePathAssignments})
  }

  loadActivePointLinks = () => {
    const activePointLinks = [];
    this.props.checkpointLinks.forEach((link) => {
      if(link.from.id === this.props.activePoint.id) {
        activePointLinks.push(link);
      }
    });

    this.setState({activePointLinks});

  }

  loadActivePointAmenities = () => {
    const activePointAmenities = [];
    this.props.checkpointItems.forEach((checkpointItem) => {
      if(checkpointItem.checkpoint.id === this.props.activePoint.id && checkpointItem.amenitiesassingment ) {
        activePointAmenities.push(checkpointItem);
      }
    });

    this.setState({activePointAmenities});

  }

  loadActivePointKiosks = () => {
    const activePointKiosks = [];
    this.props.checkpointItems.forEach((checkpointItem) => {
      if(checkpointItem.checkpoint.id === this.props.activePoint.id  && checkpointItem.kiosksassignment ) {
        activePointKiosks.push(checkpointItem);
      }
    });

    this.setState({activePointKiosks});

  }

  loadActivePointStoreAssignments = () => {
    const activePointStoreAssignments = [];
    this.props.checkpointItems.forEach((checkpointItem) => {
      if(checkpointItem.checkpoint.id === this.props.activePoint.id  && checkpointItem.storeassignments) {
        activePointStoreAssignments.push(checkpointItem);
      }
    });

    this.setState({activePointStoreAssignments});

  }

  switchFloorplan = (floorplan_id) => {
    this.props.setActiveFloorplan(floorplan_id);
  }

  getActiveFloorplan = () => {
    return this.props.floorplans.find((floorplan) => {
      return this.props.activeFloorplanID === floorplan.floorplan_id;
    });
  }

  editActiveFloorplan = () => {
    this.setState({redirect: true});
  }

  removeActiveFloorplan = () => {
    if(window.confirm(`Do you want to remove ${this.getActiveFloorplan().floorplan_name}?`)){
      this.props.removeFloorplan(this.props.activeFloorplanID, () => {
        this.props.loadCheckpointItems();
        window.location.reload();
      })
    }
  }

  removePoint = (event, activePoint) => {
    activePoint.SVGItem.remove();
    this.props.removeCheckpoint(activePoint.id, () => {
      this.props.loadCheckpointLinks();
      this.props.showHidePointPopover(false);
    });
  }

  editCheckpoint = () => {
    const tempActivePoint = Object.assign({}, this.props.activePoint);
    tempActivePoint.checkpoint_name = this.state.editCheckpointNameTemp.trim();
    this.props.setActivePoint(tempActivePoint);

    delete tempActivePoint.SVGItem;
    this.props.editCheckpoint(tempActivePoint, () => {
      this.props.loadCheckpoints();
      this.props.loadCheckpointLinks();
    });
  }

  onChangeCheckpoint = (values) => {
    this.setState({checkpointLinksValue: values});
  }

  onCheckpointsFilter = (event) => {

    const filtered = this.props.checkpoints.filter((checkpoint) => {
      return checkpoint.checkpoint_name.includes(event.target.value);
    });

    if(event.target.value.length) {
      this.setState({checkpointsFiltered: filtered.slice(0,10)});
    } else {
      this.setState({checkpointsFiltered: []});
    }
  }

  addCheckpointLink = (checkpoint_id) => {
    this.setState({checkpointsFiltered: []});
    
    const checkpoint = this.props.checkpoints.find((checkpoint) => {return checkpoint.id === checkpoint_id;});
    let distance = Math.sqrt( Math.pow(this.props.activePoint.x - checkpoint.x, 2) + Math.pow(this.props.activePoint.y - checkpoint.y, 2) );

    this.props.addCheckpointLink({from: this.props.activePoint.id, to: checkpoint_id, weight: distance}, (data) => {
      const newActivePointLink = {
        id: data.data.checkpointlink_id,
        from: this.getCheckpoint(data.data.fromcheckpoint_id),
        to: this.getCheckpoint(data.data.tocheckpoint_id),
        weight: distance,
      }
      this.setState(update(this.state, {activePointLinks: {$push: [newActivePointLink]}}));
      this.props.loadCheckpointLinks(() => {
        this.loadActivePointLinks();
      });
    });
  }

  getCheckpoint = (checkpoint_id) => {
    return this.props.checkpoints.find((checkpoint) => {
      return checkpoint.id === checkpoint_id;
    })
  }

  removeCheckpointLink = (checkpointlink_id) => {

    const newActivePointLinks = this.state.activePointLinks.filter((activePointLink) => {
      return activePointLink.id !== checkpointlink_id;
    });

    this.setState({checkpointsFiltered: [], activePointLinks: newActivePointLinks});

    this.props.removeCheckpointLink(checkpointlink_id, () => {
      this.setState(update(this.state, {pathInfoPanel: {show: {$set: false}}}));
      this.props.loadCheckpointLinks();
    });
  }

  onStoresFilter = (event) => {
    
    const storeassignments = this.props.storeassignments.map((storeassignment) => {
      return storeassignment.stores.store_id;
    });

    let filtered = this.props.stores.filter((store) => {
      return store.store_name.includes(event.target.value);
    });

    filtered = filtered.filter((store) => {
      return !storeassignments.includes(store.store_id);
    })

    if(event.target.value.length) {
      this.setState({storesFiltered: filtered.slice(0,10)});
    } else {
      this.setState({storesFiltered: []});
    }
  }

  getFloorplanByID = (floorplan_id) => {
    return this.props.floorplans.find((floorplan) => {
      return floorplan.floorplan_id === floorplan_id;
    });
  }
  
  getFileURL = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  addStoreAssignment = (store_id) => {
    this.setState({storesFiltered: []});
    const newStoreAssignment = {floor_plan_id: this.props.activeFloorplanID, store_id, room_name: this.props.activePath};
    this.props.addStoreAssignment(newStoreAssignment, () => {
      // this.setState(update(this.state, { activePathAssignments: {$push: [{newStoreAssignment}]}}));
      this.props.loadStoreAssignments(() => {
        this.loadPathTenants();
      });
    });
  }

  removeStoreAssignment = (mil_id) => {
    this.props.removeStoreAssignment(mil_id, () => {
      const newActivePathAssignments = this.state.activePathAssignments.filter((storeassignment) => {
        return storeassignment.mil_id !== mil_id;
      })
      this.setState({activePathAssignments: newActivePathAssignments});
      this.props.loadStoreAssignments();
    });

  }

  switchAmenity = (amenity_id) => {
    this.props.setActiveAmenity(amenity_id);
  }

  switchKiosk = (kiosk_id) => {
    this.props.setActiveKiosk(kiosk_id);
  }

  getActiveAmenity = () => {
    return this.props.amenities.find((amenity) => {
      return amenity.amenity_id === this.props.activeAmenity;
    });
  }

  getActiveKiosk = () => {
    return this.props.kiosks.find((kiosk) => {
      return kiosk.kiosk_id === this.props.activeKiosk;
    });
  }

  onAmenitiesFilter = (event) => {

    const activepointamenities = this.state.activePointAmenities.map((activepointamenity) => {
      return activepointamenity.amenitiesassingment.mil_id;
    });

    
    let filtered = this.props.amenitiesassignments.filter((amenityassignment) => {
      return amenityassignment.amenity.amenity.includes(event.target.value) || amenityassignment.mil_id.toString().includes(event.target.value);
    });

    filtered = filtered.filter((amenityassignment) => {
      return !activepointamenities.includes(amenityassignment.mil_id);
    })

    if(event.target.value.length) {
      this.setState({amenitiesFiltered: filtered.slice(0,10)});
    } else {
      this.setState({amenitiesFiltered: []});
    }
  }

  onKiosksFilter = (event) => {

    const activepointkiosks = this.state.activePointAmenities.map((activepointkiosk) => {
      return activepointkiosk.kiosksassignment.mil_id;
    });

    
    let filtered = this.props.kiosksassignments.filter((kioskassignment) => {
      return kioskassignment.kiosk.kiosk.includes(event.target.value) || kioskassignment.mil_id.toString().includes(event.target.value);
    });

    filtered = filtered.filter((kioskassignment) => {
      return !activepointkiosks.includes(kioskassignment.mil_id);
    })

    if(event.target.value.length) {
      this.setState({kiosksFiltered: filtered.slice(0,10)});
    } else {
      this.setState({kiosksFiltered: []});
    }
  }

  onStoreAssignmentsFilter = (event) => {
    const activepointstoreassignments = this.state.activePointStoreAssignments.map((activepointstoreassignment) => {
      return activepointstoreassignment.storeassignments.mil_id;
    });

    let filtered = this.props.storeassignments.filter((storeassignment) => {
      return storeassignment.stores.store_name.includes(event.target.value) || storeassignment.mil_id.toString().includes(event.target.value);
    });

    filtered.filter((data) => {
      if(data.floor_plan_id == 155) {
        console.log(data)
      }
    })

    filtered = filtered.filter((storeassignment) => {
      return !activepointstoreassignments.includes(storeassignment.mil_id);
    })

    // Filter already assigned checkpointitemstore
    let alreadyAssigned = [];
    this.props.checkpointItems.forEach((checkpointItem) => {
      if(checkpointItem.storeassignments) {
        alreadyAssigned.push(checkpointItem.storeassignments.mil_id)
      }
    });

    filtered = filtered.filter((storeassignment) => {
      return !alreadyAssigned.includes(storeassignment.mil_id);
    })

    if(event.target.value.length) {
      this.setState({storeAssignmentsFiltered: filtered.slice(0,10)});
    } else {
      this.setState({storeAssignmentsFiltered: []});
    }
  }

  addCheckpointAmenity = (mil_id) => {
    this.setState({amenitiesFiltered: []});
    this.props.addCheckpointAmenity({checkpoint_id: this.props.activePoint.id, mil_id}, (response) => {
      const newActivePointAmenity = {
        amenitiesassingment: this.getAmenityAssignment(response.data.data.mil_id),
        checkpoint: this.props.activePoint,
        id: response.data.data.checkpointitem_id
      };
      this.setState(update(this.state, {activePointAmenities: {$push: [newActivePointAmenity]}}));
      this.props.loadCheckpointItems(() => {
        this.loadActivePointAmenities();
      });
    });
  }

  getAmenityAssignment = (mil_id) => {
    return this.props.amenitiesassignments.find((amenityassignment) => {
      return amenityassignment.mil_id === mil_id;
    })
  }

  addCheckpointKiosk = (mil_id) => {
    this.setState({kiosksFiltered: []});
    this.props.addCheckpointKiosk({checkpoint_id: this.props.activePoint.id, mil_id}, (response) => {
      const newActivePointKiosk = {
        kioskassignment: this.getAmenityAssignment(response.data.data.mil_id),
        checkpoint: this.props.activePoint,
        id: response.data.data.checkpointitem_id
      };
      this.setState(update(this.state, {activePointKiosks: {$push: [newActivePointKiosk]}}));
      this.props.loadCheckpointItems(() => {
        this.loadActivePointKiosks();
      });
    });
  }

  getKioskAssignment = (mil_id) => {
    return this.props.kiosksassignments.find((kiosksassignment) => {
      return kiosksassignment.mil_id === mil_id;
    })
  }

  addCheckpointStoreAssignment = (mil_id) => {
    this.setState({storeAssignmentsFiltered: []});
    this.props.addCheckpointStoreAssignment({checkpoint_id: this.props.activePoint.id, mil_id}, (response) => {
      const newActivePointStoreAssignment = {
        storeassignments: this.getStoreAssignment(response.data.data.mil_id),
        checkpoint: this.props.activePoint,
        id: response.data.data.checkpointitem_id
      };
      this.setState(update(this.state, {activePointStoreAssignments: {$push: [newActivePointStoreAssignment]}}));
      this.props.loadCheckpointItems(() => {
        this.loadActivePointStoreAssignments();
      });
    });
  }

  getStoreAssignment = (mil_id) => {
    return this.props.storeassignments.find((storeassignment) => {
      return storeassignment.mil_id === mil_id;
    })
  }

  removeCheckpointAmenity = (amenitiesassingment_id) => {
    this.setState(update(this.state, {activePointAmenities: activePointAmenities => activePointAmenities.filter((activePointAmenity) => { return activePointAmenity.id !== amenitiesassingment_id})}));
    this.props.removeCheckpointAmenity(amenitiesassingment_id, () => {
      this.props.loadCheckpointItems(() => {
        this.loadActivePointAmenities();
      });
    });
  }

  removeCheckpointKiosk = (kioskassingment_id) => {
    this.setState(update(this.state, {activePointKiosks: activePointKiosks => activePointKiosks.filter((activePointKiosk) => { return activePointKiosk.id !== kioskassingment_id})}));
    this.props.removeCheckpointKiosk(kioskassingment_id, () => {
      this.props.loadCheckpointItems(() => {
        this.loadActivePointKiosks();
      });
    });
  }

  removeCheckpointStoreAssignment = (storeassingment_id) => {
    this.setState(update(this.state, {activePointStoreAssignments: activePointStoreAssignments => activePointStoreAssignments.filter((activePointStoreAssignment) => { return activePointStoreAssignment.id !== storeassingment_id})}));
    this.props.removeCheckpointStoreAssignment(storeassingment_id, () => {
      this.props.loadCheckpointItems(() => {
        this.loadActivePointStoreAssignments();
      });
    });
  }

  removeAmenityAssignment = () => {
    this.props.removeAmenityAssignment(this.props.activeAmenityAssignment.id, () => {
      this.props.showHideAmenityAssignmentPopover();
      this.props.loadAmenitiesAssignments();
    })
  }

  editKiosksAssignments = (id, {x, y, floorplan_id, kiosk_id}, pointofview) => {
    const updatedKioskAssignment = {
      coordinate_x: x,
      coordinate_y: y,
      pointofview,
      floor_plan_id: floorplan_id,
      kiosk_id,
      room_name: ''
    };

    this.props.editKiosksAssignments(id, updatedKioskAssignment, () => {
      this.props.loadKiosksAssignments();
    });
  }

  removeKioskAssignment = () => {
    this.props.removeKioskAssignment(this.props.activeKioskAssignment.id, () => {
      this.props.showHideKioskAssignmentPopover();
      this.props.loadKiosksAssignments();
    })
  }
  

  isAlreadyPlacedKiosk = (kiosk_id) => {
    const isAlreadyPlaced = this.props.kiosksassignments.find((kioskassignment) => {
      return kioskassignment.kiosk.kiosk_id === kiosk_id;
    });

    return isAlreadyPlaced ? true : false;
  }

  getPercentZoom = (input) => {
    return Math.ceil(((input - 0.02) * 100) / (0.5 - 0.02) + 100);
  }

  setKioskAssignmentRotation = (rotation) => {
    this.props.setKioskAssignmentRotation(rotation);
    clearTimeout(this.timeoutChangeRotation);
    this.timeoutChangeRotation = setTimeout(() => {
      this.editKiosksAssignments(this.props.activeKioskAssignment.id, this.props.activeKioskAssignment, this.props.kioskAssignmentRotation);
    }, 2000);
  }

  showPathInfoPanel = (show, id = null) => {
    this.setState(update(this.state, {pathInfoPanel: {show: {$set: show}}}), () => {
      if(id) {
        const point = this.props.checkpointLinks.find((point) => {
          return point.id === id;
        });
        
        point.checkpointlink_categories.forEach((category) => {
          category['text'] = category['item_name'];
        });

        this.setState(update(this.state, {pathInfoPanel: {checkPointLink: {$set: point}, path_description: {$set: point.description ? point.description : ''}, categories: {$set: point.checkpointlink_categories}}}));
      }
    });
  }

  mapCategoriesSuggestions = () => {
    let categoriesSuggestions = this.props.categories.map((category) => {
      return {id: String(category.category_id), text: category.category_name};
    });
    
    this.setState(update(this.state, {pathInfoPanel: {categoriesSuggestions: {$set: categoriesSuggestions}}}));
  }

  handlePathInfoChangeCategory = (categories) => {
    this.setState(update(this.state, {pathInfoPanel: {categories: {$set: categories}}}, () => {
    }));
  }

  handlePathInfoDescriptionChange = (e) => {
    this.setState(update(this.state, {pathInfoPanel: {path_description: {$set: e.target.value}}}));
  }

  savePathInfo = () => {

    let checkpointlink_categories = this.state.pathInfoPanel.categories;
    checkpointlink_categories.forEach((category) => {
      // console.log(category)
      if(category.id) {
        category.category_id = parseInt(category.id, 10);
      } else if (category.category_id) {
        category.category_id = parseInt(category.category_id, 10);
      }
    });

    // console.log(this.state.pathInfoPanel.categories, checkpointlink_categories);
    
    this.setState(update(this.state, {pathInfoPanel: {saving: {$set: true}}}));
    this.props.editCheckpointLink(this.state.pathInfoPanel.checkPointLink.id, {
      from: this.state.pathInfoPanel.checkPointLink.from.id,
      to: this.state.pathInfoPanel.checkPointLink.to.id,
      weight: this.state.pathInfoPanel.checkPointLink.weight,
      checkpointlink_categories,
      description: this.state.pathInfoPanel.path_description
    }, () => {
      this.setState(update(this.state, {pathInfoPanel: {saving: {$set: false}}}));
      this.props.loadCheckpointLinks();
    })
  }

  render() {

    this.autocompleteRenderCategoryInput = ({addTag, ...props}) => {
      const handleOnChange = (e, {newValue, method}) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
        }
      }
  
      const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
      const inputLength = inputValue.length
  
      let suggestions = this.state.pathInfoPanel.categoriesSuggestions.filter((category) => {
        const categoryIDs = this.state.pathInfoPanel.categories.map((category) => { return category.id; });
        return category.text.toLowerCase().slice(0, inputLength) === inputValue && categoryIDs.indexOf(category.id) === -1;
      })
  
      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion.text}
          renderSuggestion={(suggestion) => <span className="btn btn-light">{suggestion.text}</span>}
          inputProps={{...props, onChange: handleOnChange}}
          onSuggestionSelected={(e, {suggestion}) => {
            addTag(suggestion)
          }}
          onBlur={() => {return false;}}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={() => {}}
        />
      )
    }

    this.renderCategoryTag = (props) => {
      let {tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other} = props
      return (
        <span key={key} {...other} className={`btn btn-primary btn-tag`} onClick={(e) => onRemove(key)}>
          {getTagDisplayValue(tag.text)}
        </span>
      )
    }

    if(this.state.redirect) {
      return <Redirect to={`/floorplans/edit/${this.props.activeFloorplanID}`} />
    }

    let activePathInfo;
    if(this.state.pathInfoPanel.checkPointLink) {
      activePathInfo = this.state.activePointLinks.find((point) => {
        return this.state.pathInfoPanel.checkPointLink === point.id;
      })
    }

    return (
      <ContentWrapper>
        <div id="floorplansContentWrapper" style={{height: '100vh', display: 'flex', flexDirection: 'row'}}>
          <div className="inner-content"  style={{height: '100vh', flex: 5, display: 'flex', flexDirection: 'column'}}>
            <PageTitle>Floorplans</PageTitle>

            <div className="container-fluid" style={{marginBottom: '10px'}}>
              <div className="row" role="toolbar">
                <div className="col-md-9">

                  <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '1rem'}}>
                    <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `select` ? `active` : ``)} onClick={() => this.setToolbar('select')} title="Select"><i className="fa fa-mouse-pointer" aria-hidden="true"></i></button>
                    <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `drag` ? `active` : ``)} onClick={() => this.setToolbar('drag')} title="Drag"><i className="fa fa-hand-paper-o" aria-hidden="true"></i></button>
                    <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `addPoint` ? `active` : ``)} onClick={() => this.setToolbar('addPoint')} title="Add Point"><i className="fa fa-stop-circle-o" aria-hidden="true"></i></button>
                    <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `addConnector` ? `active` : ``)} onClick={() => this.setToolbar('addConnector')} title="Add Connector"><i className="fa fa-long-arrow-right" aria-hidden="true"></i></button>
                  </div>

                  {this.props.amenities.length > 0 && this.props.activeAmenity &&
                    <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '1rem'}}>
                      <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `addAmenity` ? `active` : ``)} onClick={() => this.setToolbar('addAmenity')} title="Add Amenity"><i className="fa fa-info-circle" aria-hidden="true"></i></button>
                      <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownAmenityButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>{this.getActiveAmenity().amenity_name}</span>
                      </button>
                      <div className="dropdown-menu" aria-labelledby="dropdownAmenityButton">
                        {this.props.amenities.map((amenity) => {
                          return <button  key={`amenitybutton-${amenity.amenity_id}`} className="dropdown-item" onClick={() => { this.switchAmenity(amenity.amenity_id); }}>{amenity.amenity_name}</button>;
                        })}
                      </div>
                    </div>
                  }

                  {this.props.kiosks.length > 0 && this.props.activeKiosk &&
                    <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '1rem'}}>
                      <button className={`btn btn-outline-secondary ` + (this.state.toolbar === `addKiosk` ? `active` : ``)} onClick={() => this.setToolbar('addKiosk')} title="Add Kiosk"><i className="fa fa-television" aria-hidden="true"></i></button>
                      <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownKioskButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className={`${this.isAlreadyPlacedKiosk(this.props.activeKiosk) ? `placed` : ``}`}>{this.getActiveKiosk().kiosk_name}</span>
                      </button>
                      <div className="dropdown-menu" aria-labelledby="dropdownKioskButton">
                        {this.props.kiosks.map((kiosk) => {
                          return <button  key={`kioskbutton-${kiosk.kiosk_id}`} className={`dropdown-item ${this.isAlreadyPlacedKiosk(kiosk.kiosk_id) ? `placed` : ``}`} onClick={() => { this.switchKiosk(kiosk.kiosk_id); }}>{kiosk.kiosk_name}</button>;
                        })}
                      </div>
                    </div>
                  }

                  {this.props.activeFloorplanID &&
                    <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '1rem'}}>
                      <div className="btn-group" style={{display: 'inline'}}>
                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span>{this.getActiveFloorplan().floorplan_name}</span>
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          {this.props.floorplans.map((floorplan) => {
                            return <button  key={`floorplanbutton-${floorplan.floorplan_id}`} className="dropdown-item" onClick={() => { this.switchFloorplan(floorplan.floorplan_id); }}>{floorplan.floorplan_name}</button>;
                          })}
                        </div>
                      </div>
                      <button className={`btn btn-outline-secondary `} title="Edit Floorplan" onClick={this.editActiveFloorplan}><i className="fa fa-pencil" aria-hidden="true"></i></button>
                      <button className={`btn btn-danger `} title="Remove Floorplan" onClick={this.removeActiveFloorplan}><i className="fa fa-trash" aria-hidden="true"></i></button>
                    </div>
                  }


                </div>
                <div className="col-md-3">
                  <Link to='/floorplans/add'><button className="btn btn-primary float-right">Add Floorplan</button></Link>
                </div>
              </div>
            </div>

            <div className="container-fluid" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
              <div className="row" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
                <div className="col-md-12" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
                  <div style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column', border: 'solid 1px rgba(0,0,0,.1)', padding: '0px'}}>

                    {/* Path Assignments */}
                    {this.props.showPathPopover && this.props.activePath &&
                      <div className="popover bs-popover-right" id="path-popover" style={{left: `${this.props.pathPopoverX + 15}px`, top: `${this.props.pathPopoverY - 12}px`, display: 'block'}} x-placement="right">
                        <div className="arrow"></div>
                        <h3 className="popover-title" style={{marginTop: '0px', padding: '10px'}}>Room#: {this.props.activePath}<button onClick={() => {this.props.showHidePathPopover(false);}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link float-right"><i className="fa fa-times"></i></button></h3>
                        <div className="popover-content" style={{marginTop: '0px', padding: '10px'}}>

                          <div className="autocomplete form-group">
                            <input type="text" className="form-control" placeholder="Point of Interest Name" onChange={this.onStoresFilter} />
                            {this.state.storesFiltered.length > 0 &&
                              <div className="btn-group-vertical">
                                {this.state.storesFiltered.map((storesFilteredItem) => {
                                  return (
                                    <button key={`suggestStore-${storesFilteredItem.id}`} type="button" className=" text-left btn btn-sm btn-outline-primary" onClick={(event) => {this.addStoreAssignment(storesFilteredItem.id)}}>{storesFilteredItem.store_name}</button>
                                  )
                                })}
                              </div>
                            }
                            {this.state.activePathAssignments.length > 0 &&
                              <div id="activePathAssignments">
                                {this.state.activePathAssignments.map((activePathAssignment) => {
                                  return (
                                    <div key={`activePathAssignment-${activePathAssignment.mil_id}`} id={`activePathAssignment-${activePathAssignment.mil_id}`} className="btn-group">
                                      <button type="button" className="btn btn-sm btn-outline-secondary" style={{display: 'flex', flex: 1, alignItems: 'center'}}><Avatar appearance="square" src={this.getFileURL(activePathAssignment.stores.store_image)} name="small" size="medium"/><span className="" style={{marginLeft: '10px', whiteSpace: 'normal', textAlign: 'left', lineHeight: 1}}>{activePathAssignment.stores.store_name}</span></button>
                                      <button type="button" className="btn btn-sm btn-danger" onClick={(event) => this.removeStoreAssignment(activePathAssignment.mil_id)}><i className="fa fa-times"></i></button>
                                    </div>
                                  )
                                })}
                              </div>
                            }
                          </div>

                        </div>
                      </div>
                    }

                    {/* Point Assignments */}
                    {this.props.showPointPopover && this.props.activePoint && this.props.checkpoints &&
                      <div className="popover bs-popover-right" id="point-popover" style={{left: `${this.props.pointPopoverX + 15}px`, top: `${this.props.pointPopoverY - 12}px`, display: 'block', width: '300px'}} x-placement="right">
                        <div className="arrow"></div>
                        <h3 className="popover-title" style={{marginTop: '0px', padding: '10px'}}>
                          {!this.state.editCheckpointName &&
                            <span>
                              {this.props.activePoint.checkpoint_name}
                              <button onClick={() => {this.setState({editCheckpointName: true});}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link"><i className="fa fa-pencil"></i></button>
                            </span>
                          }
                          {this.state.editCheckpointName &&
                            <span>
                              <input type="text" className="form-control form-control-sm float-left" placeholder="Checkpoint Name" style={{width: '100px'}} value={this.state.editCheckpointNameTemp} onChange={(event) => this.setState({editCheckpointNameTemp: event.target.value})} />
                              <button onClick={() => { if(this.state.editCheckpointNameTemp.length) { this.editCheckpoint(); this.setState({editCheckpointName: false});}}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link"><i className="fa fa-check"></i></button>
                            </span>
                          }
                          
                          <button onClick={() => {this.props.showHidePointPopover(false);}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link float-right"><i className="fa fa-times"></i></button></h3>
                        <div className="popover-content" style={{marginTop: '0px', padding: '10px'}}>

                          {/* Point to Point Assignments */}
                          <div><strong>Checkpoint Links</strong></div>
                          <div className="autocomplete form-group">
                            <input type="text" className="form-control form-control-sm" placeholder="Checkpoint Name" onChange={this.onCheckpointsFilter} />
                            {this.state.checkpointsFiltered.length > 0 &&
                              <div className="btn-group-vertical">
                                {this.state.checkpointsFiltered.map((checkpointsFilteredItem) => {
                                  return (
                                    <button key={`suggestPoint-${checkpointsFilteredItem.id}`} type="button" className=" text-left btn btn-sm btn-outline-primary" onClick={(event) => {this.addCheckpointLink(checkpointsFilteredItem.id)}}>{checkpointsFilteredItem.floorplan.floorplanName} - {checkpointsFilteredItem.checkpoint_name}</button>
                                  )
                                })}
                              </div>
                            }
                            {this.state.activePointLinks.length > 0 &&
                              <div id="activePointLinks">
                                {this.state.activePointLinks.map((activePointLink) => {
                                  return (
                                    <div key={`activePointLink-${activePointLink.id}`} className="btn-group">
                                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(event) => this.showPathInfoPanel(true, activePointLink.id)}>{this.getFloorplanByID(activePointLink.to.floor_plan_id).floorplan_name} - {activePointLink.to.checkpoint_name}</button>
                                      <button type="button" className="btn btn-sm btn-danger" onClick={(event) => this.removeCheckpointLink(activePointLink.id)}><i className="fa fa-times"></i></button>
                                    </div>
                                  )
                                })}
                              </div>
                            }
                          </div>

                          {/* Point to Amenities Assignments */}
                          <div><strong>Amenities Links</strong></div>
                          <div className="autocomplete form-group">
                            <input type="text" className="form-control form-control-sm" placeholder="Amenities Name" onChange={this.onAmenitiesFilter} />
                            {this.state.amenitiesFiltered.length > 0 &&
                              <div className="btn-group-vertical">
                                {this.state.amenitiesFiltered.map((amenitiesFilteredItem) => {
                                  return (
                                    <button key={`suggestAmenity-${amenitiesFilteredItem.mil_id}`} type="button" className=" text-left btn btn-sm btn-outline-primary" onClick={(event) => {this.addCheckpointAmenity(amenitiesFilteredItem.mil_id)}}>{amenitiesFilteredItem.amenity.amenity} - {amenitiesFilteredItem.mil_id}</button>
                                  )
                                })}
                              </div>
                            }
                            {this.state.activePointAmenities.length > 0 &&
                              <div id="activePointAmenities">
                                {this.state.activePointAmenities.map((activePointAmenity) => {
                                  if(activePointAmenity.amenitiesassingment){
                                    return (
                                      <div key={`activePointAmenity-${activePointAmenity.id}`} className="btn-group">
                                        <button type="button" className="btn btn-sm btn-outline-secondary">{activePointAmenity.amenitiesassingment.amenity.amenity} - {activePointAmenity.amenitiesassingment.mil_id}</button>
                                        <button type="button" className="btn btn-sm btn-danger" onClick={(event) => this.removeCheckpointAmenity(activePointAmenity.id)}><i className="fa fa-times"></i></button>
                                      </div>
                                    )
                                  } else {
                                    return null;
                                  }
                                })}
                              </div>
                            }
                          </div>

                          {/* Point to Kiosks Assignments */}
                          <div><strong>Kiosks Links</strong></div>
                          <div className="autocomplete form-group">
                            <input type="text" className="form-control form-control-sm" placeholder="Kiosks Name" onChange={this.onKiosksFilter} />
                            {this.state.kiosksFiltered.length > 0 &&
                              <div className="btn-group-vertical">
                                {this.state.kiosksFiltered.map((kiosksFilteredItem) => {
                                  return (
                                    <button key={`suggestKiosk-${kiosksFilteredItem.mil_id}`} type="button" className=" text-left btn btn-sm btn-outline-primary" onClick={(event) => {this.addCheckpointKiosk(kiosksFilteredItem.mil_id)}}>{kiosksFilteredItem.kiosk.kiosk} - {kiosksFilteredItem.mil_id}</button>
                                  )
                                })}
                              </div>
                            }
                            {this.state.activePointKiosks.length > 0 &&
                              <div id="activePointKiosks">
                                {this.state.activePointKiosks.map((activePointKiosk) => {
                                  if(activePointKiosk.kiosksassignment){
                                    return (
                                      <div key={`activePointKiosk-${activePointKiosk.id}`} className="btn-group">
                                        <button type="button" className="btn btn-sm btn-outline-secondary">{activePointKiosk.kiosksassignment.kiosk.kiosk} - {activePointKiosk.kiosksassignment.mil_id}</button>
                                        <button type="button" className="btn btn-sm btn-danger" onClick={(event) => this.removeCheckpointKiosk(activePointKiosk.id)}><i className="fa fa-times"></i></button>
                                      </div>
                                    )
                                  } else {
                                    return null;
                                  }
                                })}
                              </div>
                            }
                          </div>

                          {/* Point to Stores Assignments */}
                          <div><strong>Point of Interest Assignment Links</strong></div>
                          <div className="autocomplete form-group">
                            <input type="text" className="form-control form-control-sm" placeholder="Point of Interest Name" onChange={this.onStoreAssignmentsFilter} />
                            {this.state.storeAssignmentsFiltered.length > 0 &&
                              <div className="btn-group-vertical">
                                {this.state.storeAssignmentsFiltered.map((storeAssignmentsFilteredItem) => {
                                  
                                  return (
                                    <button key={`suggestStores-${storeAssignmentsFilteredItem.mil_id}`} type="button" className=" text-left btn btn-sm btn-outline-primary" onClick={(event) => {this.addCheckpointStoreAssignment(storeAssignmentsFilteredItem.mil_id)}}>Room# {storeAssignmentsFilteredItem.room_name} {storeAssignmentsFilteredItem.stores.store_name} - {storeAssignmentsFilteredItem.mil_id}</button>
                                  )
                                })}
                              </div>
                            }
                            {this.state.activePointStoreAssignments.length > 0 &&
                              <div id="activePointKiosks">
                                {this.state.activePointStoreAssignments.map((activePointStoreAssignment) => {
                                  if(activePointStoreAssignment.storeassignments){
                                    return (
                                      <div key={`activePointStoreAssignment-${activePointStoreAssignment.id}`} className="btn-group">
                                        <button type="button" className="btn btn-sm btn-outline-secondary">{activePointStoreAssignment.storeassignments.stores.store_name} - #{activePointStoreAssignment.storeassignments.room_name}</button>
                                        <button type="button" className="btn btn-sm btn-danger" onClick={(event) => this.removeCheckpointStoreAssignment(activePointStoreAssignment.id)}><i className="fa fa-times"></i></button>
                                      </div>
                                    )
                                  } else {
                                    return null;
                                  }
                                })}
                              </div>
                            }
                          </div>

                          <hr/>
                          <p>
                            <button onClick={ (event) => { this.removePoint(event,this.props.activePoint);}} className="btn btn-danger btn-sm" disabled={this.props.isRemovingCheckpoint}>Remove Point</button>
                          </p>
                        </div>
                      </div>
                    }

                    {/* Amenities Assignments */}
                    {this.props.showAmenityAssignmentPopover && this.props.activeAmenityAssignment &&
                      <div className="popover bs-popover-right" id="amenity-popover" style={{left: `${this.props.amenityAssignmentPopoverX + 15}px`, top: `${this.props.amenityAssignmentPopoverY - 12}px`, display: 'block'}} x-placement="right">
                        <div className="arrow"></div>
                        <h3 className="popover-title" style={{marginTop: '0px', padding: '10px'}}>{this.props.activeAmenityAssignment.id} - {this.props.activeAmenityAssignment.amenity_name}<button onClick={() => {this.props.showHideAmenityAssignmentPopover(false);}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link float-right"><i className="fa fa-times"></i></button></h3>
                        <div className="popover-content" style={{marginTop: '0px', padding: '10px'}}>
                          <p>
                            <button onClick={ (event) => { this.removeAmenityAssignment(event,this.props.activeAmenityAssignment);}} className="btn btn-danger btn-sm" disabled={this.props.isRemovingAmenitiesAssignments}>Remove Amenity</button>
                          </p>
                        </div>
                      </div>
                    }

                    {/* Kiosks Assignments */}
                    {this.props.showKioskAssignmentPopover && this.props.activeKioskAssignment &&
                      <div className="popover bs-popover-right" id="kiosk-popover" style={{left: `${this.props.kioskAssignmentPopoverX + 15}px`, top: `${this.props.kioskAssignmentPopoverY - 12}px`, display: 'block'}} x-placement="right">
                        <div className="arrow"></div>
                        <h3 className="popover-title" style={{marginTop: '0px', padding: '10px'}}>{this.props.activeKioskAssignment.id} - {this.props.activeKioskAssignment.kiosk_name}<button onClick={() => {this.props.showHideKioskAssignmentPopover(false);}} style={{marginRight: '-5px', marginTop: '-5px'}} type="button" className="btn btn-sm btn-link float-right"><i className="fa fa-times"></i></button></h3>
                        <div className="popover-content" style={{marginTop: '0px', padding: '10px'}}>
                          <div><strong>Kiosk Rotation:</strong> {this.props.kioskAssignmentRotation}&deg;</div>
                          <div style={{margin: '10px 10px'}}><Slider onChange={(value) => {this.setKioskAssignmentRotation(value)}} defaultValue={this.props.activeKioskAssignment.pointofview} min={0} max={360} /></div>
                          <p>
                            <button onClick={ (event) => { this.removeKioskAssignment(event,this.props.activeKioskAssignment);}} className="btn btn-danger btn-sm" disabled={this.props.isRemovingKiosksAssignments}>Remove Kiosk</button>
                          </p>
                        </div>
                      </div>
                    }

                    <div className="" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column', padding: '2px'}}>

                      <div className="" role="group" aria-label="Toolbar" style={{position: 'absolute', bottom: '10px', left: '25px'}} >
                        <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '10px'}} >
                          <button className="btn btn-outline-secondary" type="button" id="zoomReset">
                            <span>{this.getPercentZoom(this.props.zoom)} %</span>
                          </button>
                        </div>
                        <div className="btn-group" role="group" aria-label="Toolbar" style={{marginRight: '10px'}} >
                          <button className={`btn btn-outline-secondary ` + (this.props.gridLines ? `active` : ``)} onClick={() => this.props.toggleGridLines()} title="Toggle Gridlines"><i className="fa fa-th" aria-hidden="true"></i></button>
                          {this.props.gridLines &&
                            <div className="btn-group" style={{display: 'inline'}}>
                              <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span>{this.props.rotation}&deg;</span>
                              </button>
                              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" style={{padding: '20px'}}>
                                <Slider onChange={(value) => {this.props.setRotation(value)}} min={0} max={90} defaultValue={this.props.rotation} /> 
                              </div>
                            </div>
                          }
                          <button className={`btn btn-outline-secondary ` + (this.props.showPoints ? `active` : ``)} onClick={() => this.props.togglePoints()} title="Toggle Points"><i className="fa fa-stop-circle-o" aria-hidden="true"></i></button>
                          <button className={`btn btn-outline-secondary ` + (this.props.showAmenities ? `active` : ``)} onClick={() => this.props.toggleAmenities()} title="Toggle Amenities"><i className="fa fa-map-marker" aria-hidden="true"></i></button>
                          <button className={`btn btn-outline-secondary ` + (this.props.showKiosks ? `active` : ``)} onClick={() => this.props.toggleKiosks()} title="Toggle Kiosks"><i className="fa fa-television" aria-hidden="true"></i></button>
                          <button className={`btn btn-outline-secondary ` + (this.props.showPathIDs ? `active` : ``)} onClick={() => this.props.togglePathIDs()} title="Toggle Path IDs"><i className="fa fa-hashtag" aria-hidden="true"></i></button>
                        </div>
                      </div>

                      {this.props.isLoadingFloorplans &&
                        <div className="bg-light d-flex flex-grow-1 d-flex-center align-items-center">
                          <div className="text-center flex-grow-1"><em>Loading Floorplans</em></div>
                        </div>
                      }
                      {!this.props.isLoadingFloorplans && this.props.floorplans.length === 0 &&
                        <div className="bg-light d-flex flex-grow-1 d-flex-center align-items-center">
                          <div className="text-center flex-grow-1"><em>0 Floorplans</em></div>
                        </div>
                      }
                      {this.props.floorplans.map((floorplan) => {
                        const floorplanItem = this.props.activeFloorplanID === floorplan.floorplan_id ? <Floorplan key={`floorplan-${floorplan.floorplan_id}`} floorplan_id={floorplan.floorplan_id} floorplanURL={`${floorplan.floorplan_file}`} toolbar={this.state.toolbar} gridLines={this.state.gridLines} /> : '';
                        return floorplanItem;
                      })}
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <RightSidePanel isOpen={this.state.pathInfoPanel.show} attachPanelTo="floorplansContentWrapper" style={{width: '200px'}}>
          <div style={{padding: '30px 20px'}}>

            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <h3>Path:&nbsp;
                    {this.state.pathInfoPanel.checkPointLink ? this.getFloorplanByID(this.state.pathInfoPanel.checkPointLink.from.floor_plan_id).floorplan_name : ''} -&nbsp; 
                    {this.state.pathInfoPanel.checkPointLink ? this.state.pathInfoPanel.checkPointLink.from.checkpoint_name : ''}
                    <i className="fa fa-arrow-right mr-2 ml-2" style={{fontSize: '1rem'}}></i>
                    {this.state.pathInfoPanel.checkPointLink ? this.getFloorplanByID(this.state.pathInfoPanel.checkPointLink.to.floor_plan_id).floorplan_name : ''} -&nbsp;
                    {this.state.pathInfoPanel.checkPointLink ? this.state.pathInfoPanel.checkPointLink.to.checkpoint_name : ''}
                  </h3>
                  <hr />
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <form>
                    <div className="form-group">
                      <label htmlFor="storeCategory">Path Categories</label>
                      <TagsInput renderInput={this.autocompleteRenderCategoryInput} renderTag={this.renderCategoryTag} value={this.state.pathInfoPanel.categories} onChange={this.handlePathInfoChangeCategory} inputProps={{placeholder: 'Add a Path Category'}} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="storeDescription">Path Description</label>
                      <textarea className="form-control" id="storeDescription" rows="3" value={this.state.pathInfoPanel.path_description} onChange={this.handlePathInfoDescriptionChange} ></textarea>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <hr />
              <div className="row" role="toolbar" aria-label="Toolbar with button groups">
                <div className="col-md-12 offset-md-12 text-right">
                  <button className="btn btn-light" onClick={() => { this.showPathInfoPanel(false); }} style={{marginRight: '10px'}}>Cancel</button>
                  <button className="btn btn-primary" onClick={this.savePathInfo} disabled={this.state.pathInfoPanel.saving}>
                    {this.state.pathInfoPanel.saving ? `Saving` : `Save`}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </RightSidePanel>

      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  floorplans: state.floorplans.floorplans,
  activeFloorplanID: state.floorplans.activeFloorplanID,
  translateX: state.floorplans.translateX,
  translateY: state.floorplans.translateY,
  zoom: state.floorplans.zoom,
  showPathPopover: state.floorplans.showPathPopover,
  activePath: state.floorplans.activePath,
  pathPopoverX: state.floorplans.pathPopoverX,
  pathPopoverY: state.floorplans.pathPopoverY,
  showPointPopover: state.floorplans.showPointPopover,
  activePoint: state.floorplans.activePoint,
  checkpointLinks: state.checkpoints.checkpointLinks,
  checkpoints: state.checkpoints.checkpoints,
  isRemovingCheckpoint: state.checkpoints.isRemovingCheckpoint,
  pointPopoverX: state.floorplans.pointPopoverX,
  pointPopoverY: state.floorplans.pointPopoverY,
  storeassignments: state.stores.storeassignments,
  stores: state.stores.stores,
  gridLines: state.floorplans.gridLines,
  showPoints: state.floorplans.showPoints,
  showAmenities: state.floorplans.showAmenities,
  showKiosks: state.floorplans.showKiosks,
  showPathIDs: state.floorplans.showPathIDs,
  rotation: state.floorplans.rotation,
  isRemovingCheckpointLink: state.checkpoints.isRemovingCheckpointLink,
  amenities: state.amenities.amenities,
  kiosks: state.kiosks.kiosks,
  amenitiesassignments: state.amenities.amenitiesassignments,
  kiosksassignments: state.kiosks.kiosksassignments,
  isLoadingAmenities: state.amenities.isLoadingAmenities,
  isLoadingKiosks: state.kiosks.isLoadingKiosks,
  checkpointItems: state.checkpoints.checkpointItems,
  activeAmenity: state.floorplans.activeAmenity,
  showAmenityAssignmentPopover: state.floorplans.showAmenityAssignmentPopover,
  activeAmenityAssignment: state.floorplans.activeAmenityAssignment,
  amenityAssignmentPopoverX: state.floorplans.amenityAssignmentPopoverX,
  amenityAssignmentPopoverY: state.floorplans.amenityAssignmentPopoverY,
  isRemovingAmenitiesAssignments: state.amenities.isRemovingAmenitiesAssignments,
  activeKiosk: state.floorplans.activeKiosk,
  showKioskAssignmentPopover: state.floorplans.showKioskAssignmentPopover,
  activeKioskAssignment: state.floorplans.activeKioskAssignment,
  kioskAssignmentRotation: state.floorplans.kioskAssignmentRotation,
  kioskAssignmentPopoverX: state.floorplans.kioskAssignmentPopoverX,
  kioskAssignmentPopoverY: state.floorplans.kioskAssignmentPopoverY,
  isRemovingKiosksAssignments: state.kiosks.isRemovingKiosksAssignments,
  isLoadingFloorplans: state.floorplans.isLoadingFloorplans,
  categories: state.categories.categories,
  isLoadingCategories: state.categories.isLoadingCategories,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadFloorplans,
      setActiveFloorplan,
      setTranslateX,
      setTranslateY,
      setZoom,
      showHidePathPopover,
      setPathPopoverX,
      setPathPopoverY,
      showHidePointPopover,
      removeFloorplan,
      loadCheckpoints,
      removeCheckpoint,
      loadCheckpointLinks,
      loadCheckpointItems,
      loadStoreAssignments,
      toggleGridLines,
      setRotation,
      addStoreAssignment,
      removeStoreAssignment,
      addCheckpointLink,
      removeCheckpointLink,
      loadAmenitiesAssignments,
      addCheckpointAmenity,
      removeCheckpointAmenity,
      setActiveAmenity,
      togglePoints,
      toggleAmenities,
      toggleKiosks,
      togglePathIDs,
      showHideAmenityAssignmentPopover,
      setActiveAmenityAssignment,
      setAmenityAssignmentPopoverX,
      setAmenityAssignmentPopoverY,
      removeAmenityAssignment,
      setActiveKioskAssignment,
      showHideKioskAssignmentPopover,
      setKioskAssignmentPopoverX,
      setKioskAssignmentPopoverY,
      editCheckpoint,
      setActivePoint,
      addCheckpointKiosk,
      removeCheckpointKiosk,
      setActiveKiosk,
      loadKiosksAssignments,
      removeKioskAssignment,
      editKiosksAssignments,
      addCheckpointStoreAssignment,
      removeCheckpointStoreAssignment,
      setKioskAssignmentRotation,
      editCheckpointLink
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Floorplans);


// WEBPACK FOOTER //
// ./src/modules/Floorplans/Floorplans.js